"use client";

import { CarouselCentered } from "@/components/carouselCentered/carouselCentered.component";

import {
  FlexibleMonitoringAppPlanCard,
  type FlexibleMonitoringAppPlanSlotData,
} from "./flexibleMonitoringAppPlanCard.component";

export function FlexibleMonitoringAppSectionMobileCarousel({
  plans,
  ctaLabel,
  ctaHref,
  ctaOpenInNewTab,
}: FlexibleMonitoringAppSectionMobileCarouselProps) {
  const slides = plans.filter((p): p is FlexibleMonitoringAppPlanSlotData =>
    Boolean(p?._key),
  );

  if (slides.length === 0) return null;

  return (
    <div className="w-full" role="region" aria-label="Monitoring options">
      <CarouselCentered
        slideInnerClassName="flex min-h-0"
        ctaLabel={ctaLabel}
        ctaHref={ctaHref}
        ctaOpenInNewTab={ctaOpenInNewTab}
        ctaFilled>
        {slides.map((plan) => (
          <FlexibleMonitoringAppPlanCard key={plan._key} plan={plan} />
        ))}
      </CarouselCentered>
    </div>
  );
}

type FlexibleMonitoringAppSectionMobileCarouselProps = {
  plans: (FlexibleMonitoringAppPlanSlotData | null | undefined)[];
  ctaLabel?: string;
  ctaHref?: string;
  ctaOpenInNewTab?: boolean;
};
